export default {
    elements: {
        point: {
            radius: 0.1,
        },
    },
    legend: {
        position: 'bottom',
    },
}



// WEBPACK FOOTER //
// ./src/components/charts/commonChartOptions.js